import { node, oneOf } from "prop-types";

import { useIsLegacy } from "Login/TwoFA/stateHooks";

import useLastOrDefault from "Utilities/Hooks/useLastOrDefault";

import PromptTypography from "../PromptTypography";

const FactorDisplay = ({ type: typeArg, children: childrenArg }) => {
  const isLegacy = useIsLegacy();

  const type = useLastOrDefault(typeArg);
  const children = useLastOrDefault(childrenArg);

  return (
    <PromptTypography
      type={!isLegacy ? (type === "email" ? "copy" : "number") : undefined}
      bold
    >
      {children}
    </PromptTypography>
  );
};

FactorDisplay.propTypes = { type: oneOf(["email", "phone"]), children: node };

export default FactorDisplay;
